import React from 'react';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import { withDialogFooterSpacing } from './dialogFooterSpacing';

interface ConfirmationDialogProps {
  visible: boolean;
  onCancel: () => void;
  onContinue: () => void;
  onHide?: () => void;
  header?: string;
  message?: React.ReactNode;
  dialogStyle?: React.CSSProperties;
  confirmSeverity?: 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'help';
  confirmLabel?: string;
  cancelLabel?: string;
  icon?: React.ReactNode;
  confirmIcon?: string;
  cancelIcon?: string;
  footerClassName?: string;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  visible,
  onCancel,
  onContinue,
  onHide,
  header = 'Подтверждение',
  message = 'Есть несохраненные изменения. Вы хотите продолжить?',
  dialogStyle,
  confirmSeverity,
  confirmLabel = 'Продолжить',
  cancelLabel = 'Отмена',
  icon,
  confirmIcon,
  cancelIcon,
  footerClassName = 'gap-3'
}) => {
  return (
    <Dialog
      visible={visible}
      onHide={onHide ?? onCancel}
      header={header}
      style={dialogStyle}
      modal
      pt={withDialogFooterSpacing()}
      footer={
        <div className={footerClassName}>
          <Button
            label={confirmLabel}
            icon={confirmIcon}
            onClick={onContinue}
            severity={confirmSeverity}
          />
          <Button
            label={cancelLabel}
            icon={cancelIcon}
            onClick={onCancel}
            className="p-button-secondary"
          />
        </div>
      }
    >
      {icon ? (
        <div className="confirmation-content">
          {icon}
          <span>{message}</span>
        </div>
      ) : (
        <div>{message}</div>
      )}
    </Dialog>
  );
};

export default ConfirmationDialog;
